var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"disabled":!_vm.canClickRun},on:{"click":_vm.clickBtn}},[_vm._v(" "+_vm._s(_vm.canClickRun ? _vm.text : `重新发送(${_vm.delayTime}s)`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }